import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import FeedbackProviderContextWrapper from "components/FeedbackProvider/context/FeedbackProviderContextWrapper";
import AppLoadingScreen from "components/LoadingScreen";
import DevBar from "features/AppLayout/DevBar";
import theme from "theme";
import ErrorBoundary from "./ErrorBoundary";
import GlobalComponents from "./GlobalComponents";
import OnlineTracker from "./OnlineTracker";
import VidletRoutes from "./routes";

function App() {
  return (
    <AppLoadingScreen>
      <ThemeProvider theme={theme}>
        <DevBar
          sx={{
            position: "absolute",
            bottom: ".25rem",
            right: ".25rem",
            zIndex: 10000,
          }}
        />
        <ErrorBoundary>
          <FeedbackProviderContextWrapper>
            <CssBaseline />
            <VidletRoutes />
            <GlobalComponents />
            <OnlineTracker />
          </FeedbackProviderContextWrapper>
        </ErrorBoundary>
      </ThemeProvider>
    </AppLoadingScreen>
  );
}

export default App;
